import { GoogleAnalyticsEscriptEventName } from '@/hooks/analytics/types';
import useGoogleAnalytics from '@/hooks/analytics/useGoogleAnalytics';
import { hashedEmail } from '@/hooks/analytics/utils';
import { usePreOnboardingContext } from '@/hooks/escript/usePreOnboardingContext';
import { emitUIEvent } from '@montugroup/data-collection';
import { Box, Divider, Typography } from '@montugroup/design-system';
import { useEffect } from 'react';
import { ResendInviteButton } from '../ResendInviteButton';

type ScriptAwaitingReviewProps = {
  shouldTrack?: boolean;
};

export const ScriptAwaitingReview = ({ shouldTrack = true }: ScriptAwaitingReviewProps) => {
  const { customerDetails } = usePreOnboardingContext();
  const { sendGoogleAnalyticsEvent } = useGoogleAnalytics();
  const customerContactInfo = customerDetails?.phone || customerDetails?.email;

  // todo: emitUIEvent is an interim approach until the data collection package is updated with 'Data Events' schema
  useEffect(() => {
    sendGoogleAnalyticsEvent(GoogleAnalyticsEscriptEventName.PRESCRIPTION_SUBMIT_COMPLETE, {
      sha_email: customerDetails?.email ? hashedEmail(customerDetails?.email) : '',
      stock: 'unknown',
      product_match: 'awaiting validation',
    });

    shouldTrack
      ? emitUIEvent(
          {
            component_name: 'script_awaiting_review_screen',
            event_name: 'screenViewed',
            id: 'escript_onboarding_script_awaiting_review',
            value: 'script awaiting review screen viewed',
          },
          [],
        )
      : null;
  }, [shouldTrack]);

  return (
    <>
      <Typography variant="subtitle1" fontWeight={600} data-testid="customer-escript-script-awaiting-review">
        We&apos;re verifying your script.
      </Typography>
      <Typography>
        Stay up-to-date with the outcome by signing up with the link we&apos;ve sent to{' '}
        <Box component="span" fontWeight="bold">
          {customerContactInfo}.
        </Box>
      </Typography>

      <Typography>If your details have changed, please update them with your doctor.</Typography>

      <Divider />
      <Typography variant="body2">
        Didn&apos;t get the invite? <ResendInviteButton />
      </Typography>
    </>
  );
};
